const s = (r) => {
  let e = "";
  const t = r.slice(0, 2);
  return t === "00" ? "01/" : t.length === 1 && !t.startsWith("0") && !t.startsWith("1") ? `0${t[0]}/` : (parseInt(t) > 12 ? e = "12" : e = t, t.length === 2 && (e += "/"), e);
}, n = (r) => {
  let e = "";
  const t = r.slice(2, 4);
  return t === "00" ? "01/" : t.length === 1 && !t.startsWith("0") && !t.startsWith("1") && !t.startsWith("2") && !t.startsWith("3") ? `0${t[0]}/` : (parseInt(t) > 31 ? e = "31" : e = t, t.length === 2 && (e += "/"), e);
}, i = (r) => {
  const e = r.replace(/\D/g, "").slice(0, 8);
  let t = "";
  return e.length > 0 && (t = s(e), e.length > 2 && (t += n(e), e.length > 4 && (t += e.slice(4)))), t;
};
export {
  i as formatDate
};
